import { Alert, AppBar, Box, Button, CircularProgress, Paper, Tab, Tabs, Typography, useMediaQuery, useTheme } from '@mui/material';
import { ReactNode, useEffect, useRef, useState } from 'react';
import { useApi } from '../../../../services/HttpService';
import { EmailProvider, newEmailProvider } from '../../../../model/Email';
import { TabPanel, TabProps } from '../../../../components/ui/TabPanel';
import { DataInfoTable, DataListInfoTable } from '../../../../components/tables/DataTable';
import { EmailProviderForm, EmailProviderFormRef } from '../../../../model/forms/EmailProviderForm';

interface EmailProviderOverviewProps {
  item: EmailProvider;
  getError?: string;
  onClose?: () => void;
  onItemChange?: (item: EmailProvider) => void;
}

export const EmailProviderOverview = (props: EmailProviderOverviewProps) => {
  const theme = useTheme();
  const { getError, onItemChange } = props;
  const { api, error, isLoading } = useApi();
  const { api: modApi, error: modError, isLoading: modIsLoading } = useApi();
  const addEmailProviderRef = useRef<EmailProviderFormRef>(null);
  const [item, setItem] = useState<EmailProvider>(props.item);
  const [EmailProvider, setEmailProvider] = useState<EmailProvider>(newEmailProvider());
  const [displayData, setDisplayData] = useState<Record<string, string>>(null);
  const [tabIndex, setTabIndex] = useState(0);
  const [EmailProviderList, setEmailProviderList] = useState<EmailProvider[]>([]);
  const [SelectedEmailProvider, setSelectedEmailProvider] = useState<EmailProvider>(null);

  const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'));

  //   const getData = () => {
  //   }

  useEffect(() => {
    if (!props.item || props.item.id === 0) {
      setTabIndex(1);
    } else {
      setDisplayData({
        "ID": String(props.item.id),
        "Navn": props.item.name,
        "Smtp server": props.item.smtp_server,
        "Smtp port": props.item.smtp_port ? String(props.item.smtp_port) : "",
        "Kryptering": props.item.encryption_method,
      })
    }
  }, [props.item]);

  const reset = () => {
    setItem(() => ({ ...item, password: "" })); // triggers props.EmailProvider change in EmailProviderForm
  }

  const saveItem = () => {
    if (!addEmailProviderRef.current) return;

    // Validate the form
    if (!addEmailProviderRef.current.valid()) {
      console.log("Validation failed");
      return;
    }

    // Get form data
    const EmailProviderRef = addEmailProviderRef.current.getItem();
    console.log("Saving data:", EmailProviderRef);

    if (addEmailProviderRef.current.valid()) {
      api("/manage/email/postEmailProvider", "POST", { ...EmailProviderRef }).then(res => {
        console.log("res:", res)
        if (res?.statusCode === 200) {
          if (res.email_provider) {
            onItemChange(res.email_provider);
          }
          setTabIndex(0);
        }
      });
    }
  };

  const changeTab = (index: number, performChange: boolean = true): boolean => {
    if (!item.id) {
      if (performChange) {
        setTabIndex(1);
      }

      return index === 1
    }

    if (performChange) {
      setTabIndex(index);
    }

    return true;
  }

  return (
    <>
      <AppBar position="static"
        sx={{
          backgroundColor: theme.palette.mode === 'dark' ? "inherit" : theme.palette.grey[300],
          color: theme.palette.mode === 'dark' ? "white" : "black"
        }}
      >
        <Tabs
          value={tabIndex}
          onChange={(_, newValue) => setTabIndex(newValue)}
          variant={"scrollable"}
          textColor="inherit"
          indicatorColor="primary"
          aria-label="manage EmailProvider tabs"
        >
          {[
            "Oversikt",
            item.id ? "Rediger" : "Opprett",
          ].map((name, index) => (
            <Tab disabled={!changeTab(index, false)} key={index} label={name} sx={{ fontWeight: "bold", textTransform: "none" }} {...TabProps(index)} />
          ))}
        </Tabs>
      </AppBar>
      <Box sx={{ mt: 2, p: { xs: 0, md: 3 }, minHeight: 400 }}>
        <TabPanel value={tabIndex} index={0} sx={{ minHeight: 200 }}>
          <Box sx={{ display: 'flex', flexDirection: "column", justifyContent: 'center', gap: 3, maxWidth: { xs: "100%", md: 1200 } }}>
            <DataInfoTable title={"EmailProvider"} data={displayData} onEdit={() => changeTab(1)} />
            {props.onClose && (
              <Box sx={{ width: '100%', display: 'flex', justifyContent: 'end', p: 2 }}>
                <Button variant='contained' color='darkgrey' onClick={props.onClose}>Lukk</Button>
              </Box>
            )}
          </Box>
        </TabPanel>
        <TabPanel value={tabIndex} index={1} sx={{ minHeight: 200 }}>
          <Box sx={{ display: 'flex', flexDirection: "column", justifyContent: 'center', gap: 3, maxWidth: { xs: "100%", md: 1200 } }}>
            <EmailProviderForm item={item} error={getError} ref={addEmailProviderRef} />
            <Box sx={{ width: '100%', display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap', gap: 2, p: 2 }}>
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                {/* <Button variant='contained' color='info' onClick={setDefault}>Default</Button> */}
                <Button variant='contained' color='darkgrey' onClick={reset}>Tilbakestill</Button>
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 2 }}>
                <Button
                  variant='contained'
                  color='darkgrey'
                  onClick={() => {
                    if (changeTab(0, false)) {
                      changeTab(0);
                    } else if (props.onClose) {
                      props.onClose();
                    }
                  }}
                >
                  Avbryt
                </Button>
                <Button
                  variant='contained'
                  color='info'
                  onClick={saveItem}
                  disabled={isLoading}
                  endIcon={isLoading && <CircularProgress size={22} />}
                >
                  {item.id ? "Lagre" : "Opprett"}
                </Button>
              </Box>
            </Box>
          </Box>
        </TabPanel>
      </Box>
    </>
  )
}